import { USER_LOAD_REQUEST, USER_LOAD_SUCCESS, USER_LOAD_FAILURE } from '../types/user-types';

const initialState = {
  loading: false,
  success: false,
  error: null,
  user: null
};

function user(state = initialState, action: any = null) {
  switch (action.type) {
    case USER_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case USER_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };

    case USER_LOAD_SUCCESS:
      return {
        ...state,
        user: action.payload,
        loading: false,
        success: true,
        error: null
      };

    default:
      return state;
  }
}

export default user;
